import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Grid, Page, Group, Layout, Button } from "@/comn/components";
import { comnUtils } from "@/comn/utils";
import { useForm, useToast, useFetch, useModal, useAuth, useGrid, useResource, usePage } from "@/comn/hooks";
import { URLS, APIS, SF_MANL_RCPT_SRCH, SF_MANL_RCPT_DTL, SG_RCPT_BLL_DTL_LIST } from "./services/OsciRcptService"; // 서비스
import { colEnvs, colUtils } from "@/tz/go/egaz/osci/colt/comn";
import { SF_APRV_RQST } from "@/comn/comn/aprv/service/AprvService";
import { OgaAprvRqst } from "@/comn/comn/aprv/OgaAprvRqst";

/*
 * Manual Receipt Detail
 * !== 수작업 수납 상세 ==!
 */
export const OSCI0402006Q = () => {
    const { pgeUid, menuId } = usePage({
        auth: ["auth_osci0003", "auth_osci0021"],
    }); // Page Unique identifier !== 화면 고유 식별자 ==!
    const { t } = useTranslation(); // Translation Hook !== 언어 변환 Hook ==!
    const navigate = useNavigate(); // Navigate Hook !== 화면 이동 Hook ==!
    const modal = useModal(); // Modal Window Hook !== Modal 창 Hook ==!
    const toast = useToast(); // Toast Message Hook !== Toast 메세지 표시 Hook ==!
    const auth = useAuth(); // Login , User Information Hook !== 로그인, 유저정보 Hook ==!
    const { bllMgmtId } = useParams(); // Key Information of this Component Router !== 라우터에 정의된 키정보 ==!

    useResource({
        defaultSchema: [
            { area: "comnCd", comnCd: "OSC0056" },
            { area: "comnCd", comnCd: "OSC0058" },
            { area: "comnCd", comnCd: "OSC0065" },
            { area: "comnCd", comnCd: "OSC0067" },
            { area: "comnCd", comnCd: "OSC0020" },
            { area: "comnCd", comnCd: "OSC0096" },
            { area: "coCd" },
            { area: "bnkCd" },
            { area: "cstmCd" },
        ],
    });

    const [isVisibleBtn, setIsVisibleBtn] = useState(false);

    const [vsbTrsyVchr, setVsbTrsyVchr] = useState(false);
    const [vsbCncl, setVsbCncl] = useState(false);
    const [vsbSbmt, setVsbSbmt] = useState(false);
    const [vsbAprv, setVsbAprv] = useState(false);
    const [vsdDtls, setVsdDtls] = useState(false);

    const [bllDtlList, setBllDtlList] = useState(comnUtils.getGridData([]));

    const { aprvYn } = useParams();

    /*
     * Declaration Form
     * !== 폼 정의 ==!
     */

    const form = {
        // Manual Receipt Search !== 수작업 수납 검색 ==!
        manlRcptSrch: useForm({
            defaultSchema: SF_MANL_RCPT_SRCH,
            defaultValues: {},
        }),
        // Manual Receipt General !== 수작업 수납 일반 ==!
        manlRcptGnrl: useForm({
            defaultSchema: SF_MANL_RCPT_DTL,
            defaultValues: {},
        }),
        aprvRqstForm: useForm({
            defaultSchema: SF_APRV_RQST,
            defaultValues: {
                ptlTpCd: "O", // 포털 구분 코드 (I: 내부, O: 외부)
                bsopClsfCd: "COL", // 업무 구분 코드
                scrnDocCd: "scrn_colt0014", // 문서 ID
                aprvReffId: "/" + bllMgmtId + "/Y", // 결재 요청 문서 Key 값
                aprvAfPrcssCfgnId: "cfgn_col0025", // 결재완료 후처리 ID (결재후처리설정 테이블에 등록된 후처리ID)
                rtrnAfPrcssCfgnId: "cfgn_col0026", // 반려 후처리 ID (결재후처리설정 테이블에 등록된 후처리ID)
                prevStageRtrnUseYn: "Y", // 이전단계 반려처리가 필요한 경우에만 'Y'로 넘겨 줄 것 (결재처리 시 이전단계반려 라디오버튼을 보여줌)
                itsfAprvYn: "N", // 업무팀 자체 결재처리 시 'Y'로 넘겨 줄 것 (결재처리탭 비활성화)
            },
        }),
    };

    const today = new Date();

    /*
     * Declaration Grid
     * !== 그리드 정의 ==!
     */
    const grid = {
        // Bill Detail List !== 고지 상세 목록 ==!
        bllDtlList: useGrid({
            defaultSchema: SG_RCPT_BLL_DTL_LIST,
        }),
    };

    /*
     * Declaration Fetch
     * !== Fetch 정의 ==!
     */

    const readyFunc = {
        noData: () => {
            form.manlRcptGnrl.clearValues();
        },
        resetView: () => {
            setVsdDtls(false);
        },
        readyBll: (data: any) => {
            form.manlRcptGnrl.setValues({
                ...data.manlRcptDtl.content,
            });

            form.manlRcptSrch.setValues({
                ...data.manlRcptDtl.content,
            });

            if (data.manlRcptDtl.content.reffKeyTpCd == null || data.manlRcptDtl.content.reffKeyTpCd == "") {
                form.manlRcptGnrl.setValue("reffKey", "");
            } else {
                if (data.manlRcptDtl.content.reffKeyTpCd == "T" || data.manlRcptDtl.content.reffKeyTpCd == "B") {
                    form.manlRcptGnrl.setValue(
                        "reffKey",
                        data.manlRcptDtl.content.reffKeyNo1 +
                            "-" +
                            data.manlRcptDtl.content.reffKeyNo2 +
                            "-" +
                            data.manlRcptDtl.content.reffKeyNo3,
                    );
                } else {
                    form.manlRcptGnrl.setValue(
                        "reffKey",
                        data.manlRcptDtl.content.reffKeyNo1 +
                            "-" +
                            data.manlRcptDtl.content.reffKeyNo2 +
                            (data.manlRcptDtl.content.reffKeyNo3 ? "-" + data.manlRcptDtl.content.reffKeyNo3 : "") +
                            (data.manlRcptDtl.content.reffKeyNo4 ? "-" + data.manlRcptDtl.content.reffKeyNo4 : ""),
                    );
                }
            }

            if (data.manlRcptDtl.content.pyerTpCd == "T") {
                if (data.manlRcptDtl.content.pyerNm != null && data.manlRcptDtl.content.pyerNm != "") {
                    form.manlRcptGnrl.setValue(
                        "pyerMgmtNoNm",
                        colUtils.setMask(data.manlRcptDtl.content.pyerMgmtNo, "tin") +
                            " (" +
                            data.manlRcptDtl.content.pyerNm +
                            ")",
                    );
                } else {
                    form.manlRcptGnrl.setValue(
                        "pyerMgmtNoNm",
                        colUtils.setMask(data.manlRcptDtl.content.pyerMgmtNo, "tin"),
                    );
                }
            } else {
                if (data.manlRcptDtl.content.pyerMgmtNo == null || data.manlRcptDtl.content.pyerMgmtNo == "") {
                    form.manlRcptGnrl.setValue("pyerMgmtNoNm", data.manlRcptDtl.content.pyerNm);
                } else {
                    if (data.manlRcptDtl.content.pyerNm != null && data.manlRcptDtl.content.pyerNm != "") {
                        form.manlRcptGnrl.setValue(
                            "pyerMgmtNoNm",
                            colUtils.setMask(data.manlRcptDtl.content.pyerMgmtNo, "tin") +
                                " (" +
                                data.manlRcptDtl.content.pyerNm +
                                ")",
                        );
                    } else {
                        form.manlRcptGnrl.setValue(
                            "pyerMgmtNoNm",
                            colUtils.setMask(data.manlRcptDtl.content.pyerMgmtNo, "tin"),
                        );
                    }
                }
            }
            console.log("data", data.manlRcptDtl.content);

            const bllRgsrNm = data.manlRcptDtl.content.bllRgsrNm;
            form.manlRcptGnrl.setValue(
                "bllRgsrIdNm",
                data.manlRcptDtl.content.bllRgsrId + (bllRgsrNm ? "/" + data.manlRcptDtl.content.bllRgsrNm : ""),
            );

            if (data.manlRcptDtl.content.bllTpCd == "T") {
                setVsbTrsyVchr(true);
            }
            if (data.manlRcptDtl.content.aprvPrcssStatCd == "B03") {
                setVsbCncl(true);
            }
            if (
                data.manlRcptDtl.content.aprvPrcssStatCd == "A01" ||
                data.manlRcptDtl.content.aprvPrcssStatCd == "A03" ||
                data.manlRcptDtl.content.aprvPrcssStatCd == "B02"
            ) {
                setVsbSbmt(true);
                if (
                    data.manlRcptDtl.content.aprvPrcssStatCd == "A03" ||
                    data.manlRcptDtl.content.aprvPrcssStatCd == "B02"
                ) {
                    setVsbAprv(true);
                }
            }

            if (data.manlRcptDtl.content.bllTpCd && data.manlRcptDtl.content.bllTpCd === "G") setVsdDtls(true);
            if (data.manlRcptDtl.content.bllDtls) {
                setBllDtlList(comnUtils.getGridData(data.manlRcptDtl.content.bllDtls));
            }
        },
        readyBtn: (data: any) => {
            const aprvPrcssStatCd = data.manlRcptDtl.content?.aprvPrcssStatCd;
            const exisYn = data.manlRcptDtl.content.exisYn;

            if (exisYn == "Y" && aprvPrcssStatCd != "A01" && aprvPrcssStatCd != "A03") {
                setIsVisibleBtn(true);
            }
        },
        chkManlRcpt: (data: any) => {
            const bllPaidYn = form.manlRcptGnrl.getValue("bllPaidYn");
            const dspoYn = form.manlRcptGnrl.getValue("dspoYn");

            if (bllPaidYn == "Y") {
                modal.openModal({
                    content: "msg.osc.00185",
                });
                return false;
            }

            if (dspoYn == "Y") {
                modal.openModal({
                    content: "msg.osc.00186",
                });
                return false;
            }

            return true;
        },
    };

    const fetch = {
        // Get Manual Receipt !== 수작업 수납 조회 ==!
        getManlRcpt: useFetch({
            api: (data) => APIS.getManlRcpt(bllMgmtId),
            enabled: !!bllMgmtId,
            onSuccess: (data) => {
                readyFunc.readyBll(data);
                readyFunc.readyBtn(data);

                form.manlRcptSrch.setEditable(false);
            },
            onError: (error) => {},
            showToast: true,
        }),
        // Get Manual Receipt !== 수작업 수납 조회 ==!
        getManlRcptSrch: useFetch({
            api: (data) => APIS.getManlRcptDtl(form.manlRcptSrch.getValues()),
            onSuccess: (data) => {
                if (data.manlRcptDtl.content != null) {
                    readyFunc.resetView();
                    readyFunc.readyBll(data);
                    readyFunc.readyBtn(data);
                } else {
                    toast.showToast({ type: "warning", content: "msg.osc.00050" });
                    readyFunc.noData();
                }
            },
            onError: (error) => {
                toast.showToast({ type: "warning", content: "msg.osc.00003" });
            },
            showToast: true,
        }),
        // Manual Receipt Approval Request After !== 수작업 수납 결재 상신 후처리 ==!
        manlRcptAprvRqstAf: useFetch({
            api: (data) => APIS.manlRcptAprvRqstAf(data),
            onSuccess: (data) => {
                modal.openModal({
                    content: "msg.osc.00006",
                    onConfirm: () => {
                        navigate(URLS.osci0402005q);
                    },
                    onCancel: () => {
                        navigate(URLS.osci0402005q);
                    },
                });
            },
            onError: (data) => {},
            showToast: true,
        }),
        // manlRcptAprvAf: useFetch({
        //     api: (data) => APIS.manlRcptAprvAf(data),
        //     onSuccess: (data) => {
        //         modal.openModal({
        //             content: "msg.osc.00006",
        //             onConfirm: () => {
        //                 navigate(URLS.osci0402005q);
        //             },
        //             onCancel: () => {
        //                 navigate(URLS.osci0402005q);
        //             },
        //         });
        //     },
        //     onError: (data) => {},
        //     showToast: true,
        // }),
        // updateLpcoFeePayment: useFetch({
        //     api: (data) => APIS.updateLpcoFeePayment(data),
        //     onSuccess: (data) => {
        //         modal.openModal({
        //             content: "msg.osc.00006",
        //             onConfirm: () => {
        //                 navigate(URLS.osci0402005q);
        //             },
        //             onCancel: () => {
        //                 navigate(URLS.osci0402005q);
        //             },
        //         });
        //     },
        //     onError: (data) => {},
        //     showToast: true,
        // }),
    };

    /*
     * Declaration Event Handler
     * !== 이벤트 핸들러 정의 ==!
     */
    const handler = {
        // Get Manual Receipt Search !== 수작업 수납 검색 조회 ==!
        getManlRcptSrch: () => {
            form.manlRcptSrch.handleSubmit((data) => {
                let bllNo = form.manlRcptSrch.getValue("bllNo");
                let bllTpCd = form.manlRcptSrch.getValue("bllTpCd");
                let bllSysmCd = form.manlRcptSrch.getValue("bllSysmCd");
                let bllYy = form.manlRcptSrch.getValue("bllYy");
                let bllSrno = form.manlRcptSrch.getValue("bllSrno");
                let bllDgr = form.manlRcptSrch.getValue("bllDgr");
                // Validation Check !== 밸리데이션 체크 ==!
                if (!!!bllNo && (!!!bllTpCd || !!!bllSysmCd || !!!bllYy || !!!bllSrno || !!!bllDgr)) {
                    modal.openModal({
                        content: "msg.osc.00281",
                    });
                } else {
                    fetch.getManlRcptSrch.fetch();
                }
            })();
        },
        // Get Submit Manual Receipt !== 제출 수작업 수납 조회 ==!
        sbmtManlRcpt: () => {
            form.manlRcptGnrl.handleSubmit((data) => {
                let chkFlag = true;
                chkFlag = readyFunc.chkManlRcpt(data);

                if (chkFlag) {
                    alert("Submission and Post-processing");
                }
            })();
        },
        // Get Cancel Manual Receipt !== 취소 수작업 수납 조회 ==!
        cnclManlRcpt: () => {
            form.manlRcptGnrl.handleSubmit((data) => {
                alert("Cancel request submission and Post-processing");
            })();
        },
        // Click Apprvoal Request Button !== 결재 요청 버튼 클릭 ==!
        onAprvRqstBtnClick: () => {
            modal.openModal({
                content: (
                    <OgaAprvRqst
                        paramData={{
                            bsopClsfCd: "OSC", // 업무시스템 구분
                            scrnDocCd: "scrn_colt0014", // 화면문서코드테이블에 등록된 화면문서ID
                        }}
                        callbackFn={(aprvData: any) => {
                            if (aprvData) {
                                form.aprvRqstForm.setValues({
                                    aprvId: aprvData.aprvId,
                                    aprvRqstTtleNm: aprvData.aprvRqstTtleNm,
                                    aprvRqstCn: aprvData.aprvRqstCn,
                                    usrDmnId: aprvData.usrDmnId,
                                    aprvPrcssPathMgmtId: aprvData.aprvPrcssPathMgmtId,
                                });

                                const param = {
                                    ...form.manlRcptSrch.getValues(),
                                    aprvRqstDto: form.aprvRqstForm.getValues(),
                                };
                                console.log("callbackFn data", param);
                                fetch.manlRcptAprvRqstAf.fetch(param);
                            }
                            modal.closeModal("OgaAprvRqst");
                        }}
                    />
                ),
                size: "md",
                draggable: true,
                close: false,
                id: "OgaAprvRqst",
            });
        },
        // // Click Apprvoal Request Button !== 결재 요청 버튼 클릭 ==!
        // onAprvCmptBtnClick: () => {
        //     form.manlRcptGnrl.handleSubmit((data) => {
        //         let bllNo = `${data.bllCstmOfceCd}-${data.bllYy}-${data.bllTpCd}-${data.bllSrno}-${data.bllDgr}-${data.bllRcptSrno}`;
        //         let aprvReffId = `${data.bllNo}/${bllNo}`;
        //         const aprv_data = { ...data, aprvReffId: aprvReffId };
        //         fetch.manlRcptAprvAf.fetch(aprv_data);
        //     })();
        // },
        // // Click Apprvoal Request Button !== 결재 요청 버튼 클릭 ==!
        // updateLpcoFeePaymentBtnClick: () => {
        //     form.manlRcptGnrl.handleSubmit((data) => {
        //         let bllNo = `${data.bllCstmOfceCd}-${data.bllYy}-${data.bllTpCd}-${data.bllSrno}-${data.bllDgr}`;
        //         fetch.updateLpcoFeePayment.fetch(bllNo);
        //     })();
        // },
    };

    const render = {
        grid_bllDtlList: {
            head: {},
            cell: {
                bllMgmtId: (props: any) => {
                    const { binding, rowValues, value } = props;
                    return (
                        <span>
                            {`${rowValues.bllTpCd}-${rowValues.bllSysmCd}-${rowValues.bllYy}-${rowValues.bllSrno}-${rowValues.bllDgr}`}
                        </span>
                    );
                },
            },
            edit: {},
        },
    };

    useEffect(() => {
        form.manlRcptSrch.setEditable(true);
        form.manlRcptGnrl.setEditable(false);
    }, []);

    return (
        <Page>
            {aprvYn != "Y" && (
                <Group>
                    <Group.Body>
                        <Group.Section>
                            <Group.Row>
                                <Group.Control {...form.manlRcptSrch.schema.bllNo} />
                            </Group.Row>
                            <Group.Row>
                                <Group.Label {...form.manlRcptSrch.schema.bllMgmtId}></Group.Label>
                                <Group.Field size={4}>
                                    <Group.Control {...form.manlRcptSrch.schema.bllTpCd} />
                                    <Group.Any>-</Group.Any>
                                    <Group.Control {...form.manlRcptSrch.schema.bllSysmCd} />
                                    <Group.Any>-</Group.Any>
                                    <Group.Control {...form.manlRcptSrch.schema.bllYy} />
                                    <Group.Any>-</Group.Any>
                                    <Group.Control {...form.manlRcptSrch.schema.bllSrno} />
                                    <Group.Any>-</Group.Any>
                                    <Group.Control {...form.manlRcptSrch.schema.bllDgr} />
                                    <Group.Any>-</Group.Any>
                                    <Group.Control {...form.manlRcptSrch.schema.bllRcptSrno} />
                                </Group.Field>
                            </Group.Row>
                        </Group.Section>
                        {/* <Layout direction="row">
                            <Layout.Left>
                                <Button
                                    role="reset"
                                    onClick={() => {
                                        form.manlRcptSrch.reset();
                                    }}
                                ></Button>
                            </Layout.Left>
                            <Layout.Right>
                                <Button
                                    role="search"
                                    onClick={() => {
                                        handler.getManlRcptSrch();
                                    }}
                                ></Button>
                            </Layout.Right>
                        </Layout> */}
                    </Group.Body>
                </Group>
            )}

            <Group>
                <Group.Body>
                    <Group.Title title={"L_BLL_GNRL"} titleSize={2}></Group.Title>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.manlRcptGnrl.schema.bllNo} />
                            <Group.Control {...form.manlRcptGnrl.schema.bllDt} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.manlRcptGnrl.schema.ctrlNo} />
                            <Group.Control {...form.manlRcptGnrl.schema.zmpDt} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.manlRcptGnrl.schema.bllTpCdSec} />
                            <Group.Control {...form.manlRcptGnrl.schema.bllStatCd} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.manlRcptGnrl.schema.pyerMgmtNoNm} />
                            <Group.Control {...form.manlRcptGnrl.schema.bllRgsrIdNm} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.manlRcptGnrl.schema.reffKeyTpCd} />
                            <Group.Control {...form.manlRcptGnrl.schema.reffKey} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.manlRcptGnrl.schema.feeAmt} />
                            <Group.Control {...form.manlRcptGnrl.schema.bllMgmtId} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.manlRcptGnrl.schema.payDdlnDt} />
                            <Group.Control {...form.manlRcptGnrl.schema.lastDdlnXtnsDt} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.manlRcptGnrl.schema.xtnsDt} />
                            <Group.Control {...form.manlRcptGnrl.schema.lastDdlnXtnsRsn} />
                        </Group.Row>
                    </Group.Section>
                </Group.Body>
            </Group>
            {vsdDtls && (
                <Group>
                    <Group.Body>
                        {" "}
                        <Layout direction="row">
                            <Layout.Left>
                                <Group.Title title={"T_BLL_DTL_1"} titleSize={2}></Group.Title>
                            </Layout.Left>
                        </Layout>
                        <Grid {...grid.bllDtlList.grid} data={bllDtlList} render={render.grid_bllDtlList} />
                    </Group.Body>
                </Group>
            )}
            <Group>
                <Group.Body>
                    <Group.Title title={"L_MANL_RCPT"} titleSize={2}></Group.Title>

                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.manlRcptGnrl.schema.payMetdCd} />
                            <Group.Control {...form.manlRcptGnrl.schema.aprvPrcssStatCd} />
                        </Group.Row>
                        {vsbTrsyVchr && (
                            <Group.Row>
                                <Group.Control {...form.manlRcptGnrl.schema.trsyVchrNo} />
                                <Group.Control {...form.manlRcptGnrl.schema.manlRcptRsn} />
                            </Group.Row>
                        )}
                        {!vsbTrsyVchr && (
                            <Group.Row>
                                <Group.Control {...form.manlRcptGnrl.schema.rcptBnkCd} />
                                <Group.Control {...form.manlRcptGnrl.schema.rcptBnkAcctNo} />
                            </Group.Row>
                        )}
                        {!vsbTrsyVchr && (
                            <Group.Row>
                                <Group.Control {...form.manlRcptGnrl.schema.rcptNo} />
                                <Group.Control {...form.manlRcptGnrl.schema.manlRcptRsn} />
                            </Group.Row>
                        )}
                        <Group.Row>
                            <Group.Control {...form.manlRcptGnrl.schema.rcptAmt} />
                            <Group.Control {...form.manlRcptGnrl.schema.rcptDt} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.manlRcptGnrl.schema.rcptRgsrOfcrNm} />
                            <Group.Control {...form.manlRcptGnrl.schema.rcptRgsrDt} />
                        </Group.Row>
                        {vsbCncl && (
                            <Group.Row>
                                <Group.Control {...form.manlRcptGnrl.schema.lastMdfrNm} />
                                <Group.Control {...form.manlRcptGnrl.schema.lastMdfyDtm} />
                            </Group.Row>
                        )}
                        {vsbSbmt && (
                            <Group.Row>
                                <Group.Control {...form.manlRcptGnrl.schema.sbmrNm} />
                                <Group.Control {...form.manlRcptGnrl.schema.sbmsDt} />
                            </Group.Row>
                        )}
                        {vsbAprv && (
                            <Group.Row>
                                <Group.Control {...form.manlRcptGnrl.schema.autrNm} />
                                <Group.Control {...form.manlRcptGnrl.schema.audtDt} />
                            </Group.Row>
                        )}
                        {vsbAprv && (
                            <Group.Row>
                                <Group.Control {...form.manlRcptGnrl.schema.aprvRmrk} />
                            </Group.Row>
                        )}
                    </Group.Section>
                </Group.Body>
            </Group>

            {aprvYn != "Y" && (
                <Layout direction="row">
                    <Layout.Left>
                        <Button
                            role="list"
                            onClick={() => {
                                navigate(URLS.osci0402005q);
                            }}
                        ></Button>
                    </Layout.Left>
                    {isVisibleBtn && (
                        <Layout.Right>
                            {/* <Button variant="primary" onClick={handler.onAprvRqstBtnClick}>
                                {t("B_APRV_RQST")}
                            </Button> */}
                            {/* <Button variant="primary" onClick={handler.onAprvCmptBtnClick}>
                                {t("L_APRV_CMPT_TAB")}
                            </Button>
                            <Button variant="primary" onClick={handler.updateLpcoFeePaymentBtnClick}>
                                [TEST]LPCO APPLY
                            </Button> */}
                        </Layout.Right>
                    )}
                </Layout>
            )}
        </Page>
    );
};
